export default "__VITE_ASSET__BYi3Xr8J__"